var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgError = function SvgError(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M1.344 11.38a2.56 2.56 0 0 1 0-2.56l3.141-5.44a2.56 2.56 0 0 1 2.22-1.28h6.278c.914 0 1.76.487 2.22 1.28l3.137 5.44a2.56 2.56 0 0 1 0 2.56l-3.14 5.44a2.56 2.56 0 0 1-2.22 1.28H6.7c-.914 0-1.76-.487-2.22-1.28zm8.498-5.833a.85.85 0 0 0-.854.854v3.984c0 .473.381.853.854.853s.854-.38.854-.853V6.4a.85.85 0 0 0-.854-.854m1.138 7.968a1.138 1.138 0 1 0-2.276 0 1.138 1.138 0 0 0 2.276 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export default ForwardRef;